<template>
  <div class="msg_container">
    <Tabbar :title="$t('common.systemMessage')" background="#fff"></Tabbar>
    <van-list
      v-if="loading || msgList.length > 0"
      v-model="loading"
      :finished="finished"
      :loading-text="$t('home.loading')"
      @load="getMsgList(page++, pageSize)"
    >
      <van-cell
        v-for="item in msgList"
        :key="item.messageId"
        @click="readMsg(item.messageId, item.jumpLink, item.isRead)"
        class="msg_item_box"
      >
        <div class="time">{{ item.sendTime }}</div>
        <div class="msg_item">
          <img class="msg_img" v-show="item.picUrl" :src="item.picUrl" alt="" />
          <div class="content_box">
            <div class="flex title_box">
              <div>{{ item.title }}</div>
              <div v-show="item.isRead == 2" class="read_dot"></div>
            </div>
            <div class="content" v-html="item.content"></div>
          </div>
        </div>
      </van-cell>
    </van-list>
    <NoData v-else class="no_data_box" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import NoData from '@/components/noData.vue'

export default {
  name: 'Message',
  components: { Tabbar, NoData },
  data() {
    return {
      msgList: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false
    }
  },
  methods: {
    readMsg(messageId, jumpLink, isRead) {
      let data = {
        userId: this.$store.state.userInfo.userId,
        messageId
      }
      this.$http
        .post(window.serverPath + '/api/user/system/message/read_message', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            if (jumpLink) {
              window.location.href = jumpLink
            } else if (isRead === 2) {
              this.$router.go(0)
            }
          }
        })
        .catch((err) => console.log(err))
    },
    getMsgList(page, pageSize) {
      this.loading = true
      let data = {
        userId: this.$store.state.userInfo.userId,
        page,
        pageSize
      }
      this.$http
        .post(window.serverPath + '/api/user/system/message/list', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.msgList = [...this.msgList, ...res.data.data].map((item) => {
              let time = item.sendTime.split(' ')[0]
              if (time === this.getNowDate()) {
                item.sendTime = 'Today ' + item.sendTime.split(' ')[1]
              }
              return item
            })
            this.loading = false
            console.log(this.msgList.length, res.data.data)
            if (res.data.data.length < 10) {
              this.finished = true
            }
          }
        })
        .catch((err) => console.log(err))
    },
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      const NOW_MONTHS_AGO = `${day}/${month}/${year}`
      return NOW_MONTHS_AGO
    }
  },
  mounted() {
    this.getMsgList(this.page++, this.pageSize)
  }
}
</script>

<style scoped>
.msg_container {
  height: 100%;
  width: 100%;
  background: #eef1f7;
  padding-bottom: 0.2rem;
  overflow-y: auto;
  scrollbar-width: none;
}

.msg_container::-webkit-scrollbar {
  width: 0;
}

.no_data_box {
  height: calc(100% - 0.4rem);
}

.van-cell {
  background: #eef1f7;
  padding: 0;
}

.time {
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(68, 57, 86, 0.4);
  margin: 0.12rem auto 0.06rem;
  text-align: center;
}

.msg_item {
  width: 3.55rem;
  min-height: 0.89rem;
  background: #ffffff;
  border-radius: 0.06rem;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: left;
  overflow: hidden;
}

.title_box {
  font-size: 0.16rem;
  font-weight: 600;
  color: #443956;
  line-height: 0.22rem;
  margin-bottom: 0.03rem;
  justify-content: space-between;
}

.content_box {
  padding: 0.12rem;
}

.read_dot {
  width: 0.08rem;
  height: 0.08rem;
  background: #ff4c62;
  border-radius: 50%;
}

.content {
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(68, 57, 86, 0.5);
  line-height: 0.2rem;
}

.flex {
  display: flex;
  align-items: center;
}

.msg_img {
  width: 100%;
  max-height: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Message.vue